<locations-selector
  [config]="config"
  [regionId]="regionId"
  [selected]="selected"
  (selectedChange)="update($event)"
></locations-selector>
